import { Stack, TextFieldProps } from "@mui/material";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers";
import { BaseToolbarProps } from "@mui/x-date-pickers/internals";
import { isEmpty } from "lodash";
import { JSXElementConstructor, type FC } from "react";
import { useController } from "react-hook-form";
import * as StyledCommon from "./Common.styled";
import * as Styled from "./DatePicker.styled";
import { FormError } from "./FormError";
import * as StyledTextInput from "./TextInput.styled";

type DatePickerProps = TextFieldProps & {
    name: string;
    disabled?: boolean;
    label?: string;
    placeholder?: string;
    sublabel?: string;
    ToolbarComponent?: JSXElementConstructor<BaseToolbarProps<any, any>>;
    LabelComponent?: React.ElementType;
    WrapperComponent?: React.ElementType;
};

export const DatePicker: FC<DatePickerProps> = ({
    name,
    disabled,
    label,
    sublabel,
    placeholder,
    ToolbarComponent,
    LabelComponent = "label",
    WrapperComponent = Stack,
}) => {
    const { fieldState, field } = useController({ name });
    const { error } = fieldState;

    return (
        <WrapperComponent>
            {!isEmpty(label) && (
                <LabelComponent htmlFor={`${name}-name`}>
                    <StyledCommon.InputLabel>{label}</StyledCommon.InputLabel>
                </LabelComponent>
            )}
            {!isEmpty(sublabel) && <StyledCommon.InputSubLabel>{sublabel}</StyledCommon.InputSubLabel>}
            <MUIDatePicker
                components={{
                    LeftArrowIcon: Styled.DatePickerCaretLeft,
                    RightArrowIcon: Styled.DatePickerCaretRight,
                    SwitchViewIcon: Styled.DatePickerSwitchViewIcon,
                    OpenPickerIcon: Styled.DatePickerCalendarIcon,
                }}
                mask="__.__.____"
                inputFormat="dd.MM.yyyy"
                ToolbarComponent={ToolbarComponent}
                value={field.value}
                onChange={(newValue) => {
                    if (newValue instanceof Date) {
                        field.onChange(newValue);
                    } else if (newValue === null) field.onChange(null);
                }}
                disabled={disabled}
                renderInput={(params) => {
                    return (
                        <StyledTextInput.TextField
                            {...params}
                            inputProps={{
                                ...params.inputProps,
                                placeholder: placeholder,
                            }}
                            placeholder={placeholder}
                            name={name}
                            onChange={() => null}
                        />
                    );
                }}
            />
            <FormError error={error} fieldName={name} />
        </WrapperComponent>
    );
};
